import React, {Fragment, useState, useEffect} from 'react';

const RteUsuariosPorRol = ({nombre, items}) => {
  const [fechaActual, setFechaActual] = useState('');

  useEffect(() => {
    let fecha = new Date();
    let dia = fecha.getDate();
    let mes = fecha.getMonth() + 1; // Sumar 1 porque los meses son de 0 a 11
    const anio = fecha.getFullYear();

    setFechaActual(`${dia}/${mes}/${anio}`);
  }, []);

  const nombreRolHumanizado = (rol) => {
    if(rol === 'Admin') {
      return 'Administrador'
    } else if(rol === 'MesaEntrada') {
      return 'Mesa de Entrada'
    } else {
      return rol
    }
  }

    return (
        <div>
          <h4>{nombre} al {fechaActual}</h4>
          <div className="row">
              <div className="col-sm-2 fw-bold"></div>
              <div className="col-sm-6 fw-bold">Nombre</div>
              <div className="col-sm-4 fw-bold">Organismo</div>
          </div>   

          {(() => {
            let lastRol = null;
            let toggle = false;
          
            return items.map((item, index) => {
              // si cambia el rol respecto al anterior, cambio cabecera
              toggle = item.rol !== lastRol
              if (item.rol !== lastRol) {
                lastRol = item.rol;
              }
                                
              return (
                <Fragment key={index}>
                  {
                    toggle && (
                    <div>
                        <h5 className='p-0'>{nombreRolHumanizado(item.rol)}</h5>
                    </div>
                    )
                  }
                  <div className="row" style={{fontSize: '0.8rem'}}>
                      <div className="col-sm-2">
                          &nbsp;
                      </div>
                      <div className="col-sm-6 text-uppercase">
                          {item.nombre}
                      </div>
                      <div className="col-sm-4 text-uppercase">
                          {item.organismos}
                      </div>
                  </div>
                </Fragment>
              )
            })
            })()}
        </div>
    );
};

export default RteUsuariosPorRol;